import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';

import 'normalize.css';
import './src/styles/global.scss';

export function wrapPageElement({ element, props }) {
    return <ParallaxProvider {...{ ...props }}>{element}</ParallaxProvider>
}